const WORDS = ["Journey", "Empower", "Motivate", "Self-Advocacy", "Independence", "Education", "Employment Readiness", "Resilience"];

export const Marquee = () => (
  <section aria-label="JEM themes" className="marquee overflow-hidden border-y border-[#D4AF37]/20 bg-[#07080A] py-7" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max items-center" aria-hidden="true">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center">
          {WORDS.map((w, i) => (
            <span key={`${k}-${w}`} className="flex items-center">
              <span className={`whitespace-nowrap px-8 font-display text-4xl sm:text-6xl ${i % 2 ? "italic text-[#F3C649]" : "text-[#F9F8F6]"}`}>{w}</span>
              <span className="text-2xl text-[#D4AF37]">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
    <p className="sr-only">{WORDS.join(", ")}</p>
  </section>
);
